export default "<div> Coming soon...</div>\n";